import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "info-tooltip cursor-pointer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-tooltip flex-center-content font-500",
    style: _normalizeStyle(_ctx.tooltip_style)
  }, [
    (_ctx.has_custom_content_slot)
      ? _renderSlot(_ctx.$slots, "content", {}, undefined, true, 0)
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "?", -1)
        ]))])),
    _createElementVNode("div", {
      class: _normalizeClass(["tooltip-content", 'tooltip-' + _ctx.position]),
      style: _normalizeStyle(
				{
					width: _ctx.width_in_px ? _ctx.width_in_px + 'px' : undefined,
					color: _ctx.text_color
				} as any
			)
    }, [
      (_ctx.tooltip_text)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "p-t-xxs p-b-xxs p-l-xxs p-r-xxs font-s text-left",
            style: _normalizeStyle(
					{
						'white-space': _ctx.single_line_tooltip_text ? 'nowrap' : 'initial'
					} as any
				)
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.tooltip_text), 1)
          ], 4))
        : _renderSlot(_ctx.$slots, "tooltip-content", {}, undefined, true, 1)
    ], 6)
  ], 4))
}